<template>
  <qx-card title="列表">
    <section slot="titleRight">
      <qx-permpisions permpisions="10090101">
        <ExportBtn
            :len="tableData.data.length"
            queryUrl="inventoryManagementBO.ajax?cmd=getInventoryList"
            :params="fullSearchData"
            bizName="库存列表数据导出"
            bizCode="exp100901"
            :excelKeys="excelKeys"
            :excelLables="excelLables"
        />
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!--    表格-->
      <section class="tableBox" ref="tableBox">
        <el-table v-loading="tableData.loading" ref="multipleTable" :data="tableData.data" tooltip-effect="dark"
                  :height="tableHeight" @select="handleSelectionChange" @select-all="handleSelectionChange">
          <!--        常规列表项-->
          <template v-for="(item, index, key) in tableData.title">
            <el-table-column :key="key" :prop="item.prop" :label="item.label" :sortable="item.sortable"
                             :filters="item.filters" :filter-method="item.filterHandler" :min-width="item.minW"
                             :width="item.w" :fixed="item.fixed" align="center">
            </el-table-column>
          </template>
          <!--        常规列表项end-->
        </el-table>
      </section>
      <!--    表格end-->
      <!--    分页-->
      <section class="paginationBox clearPa">
        <!--      分页组件-->
        <section class="right">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                         :current-page="tableData.page" :page-sizes="[10,20,50]" :page-size="tableData.count"
                         layout="total, sizes, prev, pager, next, jumper" :total="tableData.total"></el-pagination>
        </section>
        <!--      分页组件end-->
      </section>
      <!--    分页end-->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import ExportBtn from 'components/exportBtn';
import {getInventoryListApi} from 'api/service';

export default {
  mixins: [
    tableMixin,
  ],
  components: {
    ExportBtn,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        title: [ // 表头
          {prop: 'accessoryName', label: '配件名称'},
          {prop: 'accessoryModel', label: '型号'},
          {prop: 'unitPriceDouble', label: '单价（元）'},
          {prop: 'inventoryQuantity', label: '剩余库存量'},
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: getInventoryListApi,
  },
};
</script>
